import { memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowTypography } from './GlowTypography';
import { GlowTypographyProps } from './GlowTypographyProps';

export const GlowTextBody: ComponentMemo<GlowTypographyProps> = memo(({ ...props }) => {
    return <GlowTypography fontSize={'body'} {...props} />;
});

GlowTextBody.displayName = 'GlowTextBody';
